import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "../Dashboard/Dashboard";
import Login from "../Login/Login";
import Form from "../Form/Form";
import RegisteredSuccessfully from "../Form/RegisteredSuccessfully";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route exact path="*" element={<Dashboard />} />
        <Route path="/form" element={<Form />} />
        <Route path="/confirm" element={<RegisteredSuccessfully />} />
      </Routes>
    </BrowserRouter>
  );
};
export default Router;
